import React from 'react';
import './Button.css';

export function Button({ children, variant = 'default', size = 'md', ...props }) {
  return (
    <button className={`btn btn-${variant} btn-${size}`} {...props}>
      {children}
    </button>
  );
}
